export class UserTokenModel {
    jwt: string;
    decodedJwt: any;
    refreshToken: string;
    keepMeSignedIn: boolean;
    issuedUtc: Date;
    expiresUtc: Date;
}
